export default {
  "sections": [
      {
          "icon": "details",
          "name": "Details",
          "sections": [
              {
                  "actions": true,
                  "name": "Attributes",
                  "schema": [
                      {
                          "field": "v-address",
                          "label": "Address",
                          "vvalidate": "required",
                          "updateheader": true
                      },
                      // {
                      //     "field": "v-text-field",
                      //     "label": "Asset No",
                      //     "vvalidate": "required",
                      //     "updateheader": true
                      // },
                      {
                            "field": "v-tree-select",
                            "label": "Location Type",
                            "updateheader": true,
                            "vvalidate": "required"
                      },
                      {
                          "field": "v-client-contact",
                          "label": "Client Contact",
                          "vvalidate": "required",
                      },
                      {
                          "field": "v-tree-select",
                          "label": "Inspection Purpose",
                          "vvalidate": "required",
                          "updateheader": true
                      },
                      {
                          "field": "v-text-field",
                          "label": "Project Reference",
                          // "vvalidate": "required",
                          "updateheader": true
                      },
                      {
                          "field": "v-tree-select",
                          "label": "Weather",
                          "updateheader": true
                      },
                      {
                        "field": "v-text-field",
                        "label": "Remark",
                        "updateheader": true
                      }
                  ]
              }
          ]
      },
      {
          "icon": "vertical_align_top",
          "name": "Above Ground",
          "sections": [
              {
                  "actions": true,
                  "name": "Attributes",
                  "schema": [
                      {
                        "field": "v-tree-select",
                        "label": "Node Type",
                        "updateheader": true,
                        "vvalidate": "required"
                      },
                      {
                          "field": "v-tree-select",
                          "label": "Material",
                          "updateheader": true
                          // "vvalidate": "required"
                      },
                      {
                          "field": "v-tree-select",
                          "label": "Shape",
                          "updateheader": true
                          // "vvalidate": "required"
                      },
                      {
                          "field": "v-tree-select",
                          "label": "Diameter",
                          "updateheader": true
                          // "vvalidate": "required"
                      },
                      {
                        "field": "v-tree-select",
                        "label": "Width",
                        "updateheader": true
                        // "vvalidate": "required"
                      },
                    //   {
                    //       "field": "v-text-field",
                    //       "label": "Width",
                    //       "updateheader": true
                    //   },
                      {
                          "field": "v-text-field",
                          "label": "Remark",
                          "updateheader": true
                      }
                  ]
              },
              {
                  "actions": true,
                  "name": "Observation",
                  "schema": [
                      {
                          "field": "v-tree-select-enhanced",
                          "label": "Observation"
                      },
                      {
                          "field": "v-text-field",
                          "label": "Remark",
                          "updateheader": true
                      }
                  ]
              }
          ]
      },
  ],
  "treeSelectSchema": [
      {
          "code": "RM-BO-HB",
          "description": "Breaking",
          "feature": "Base",
          "type": "Observation",
          "field": "Observation",
          "dualLayer": true,
          "children": [
              {
                  "code": "RM-BO-HB-D",
                  "description": "Displaced pieces"
              },
              {
                  "code": "RM-BO-HB-M",
                  "description": "Missing one or more pieces of maintenance structure"
              }
          ]
      },
      {
          "code": "RM-BO-HBC",
          "description": "Base Channel and Benching in Good Condition",
          "feature": "Base",
          "type": "Observation",
          "field": "Observation",
          "dualLayer": true,
          "children": [
              {
                  "code": "RM-BO-HBC-GC",
                  "description": "Base Channel and benching in good condition"
              }
          ]
      },
      {
          "code": "RM-BO-HCH",
          "description": "Defective Channel - Benching",
          "feature": "Base",
          "type": "Observation",
          "field": "Observation",
          "dualLayer": true,
          "children": [
              {
                  "code": "RM-BO-HCH-D",
                  "description": "Channel defective"
              },
              {
                  "code": "RM-BO-HCH-T",
                  "description": "Turbulence within channel"
              }
          ]
      },
      {
          "code": "RM-BO-HCX",
          "description": "Defective Connection",
          "feature": "Base",
          "type": "Observation",
          "field": "Observation",
          "dualLayer": true,
          "children": [
              {
                  "code": "RM-BO-HCX-B",
                  "description": "Blocked"
              },
              {
                  "code": "RM-BO-HCX-D",
                  "description": "Damaged"
              },
              {
                  "code": "RM-BO-HCX-DP",
                  "description": "Defective pipework"
              },
              {
                  "code": "RM-BO-HCX-GA",
                  "description": "Gap around conduit to maintenance structure"
              },
              {
                  "code": "RM-BO-HCX-P",
                  "description": "Incorrect position"
              },
              {
                  "code": "RM-BO-HCX-I",
                  "description": "Intruding connection"
              },
              {
                  "code": "RM-BO-HCX-Z",
                  "description": "Other defect"
              }
          ]
      },
      {
          "code": "RM-BO-HDE",
          "description": "Deposits in Channel",
          "feature": "Base",
          "type": "Observation",
          "field": "Observation",
          "dualLayer": true,
          "children": [
              {
                  "code": "RM-BO-HDE-E",
                  "description": "Encrustation"
              },
              {
                  "code": "RM-BO-HDE-F",
                  "description": "Fouling"
              },
              {
                  "code": "RM-BO-HDE-R",
                  "description": "Gravel or rubble"
              },
              {
                  "code": "RM-BO-HDE-G",
                  "description": "Grease or fat"
              },
              {
                  "code": "RM-BO-HDE-C",
                  "description": "Hard or compacted"
              },
              {
                  "code": "RM-BO-HDE-Z",
                  "description": "Other material deposited"
              },
              {
                  "code": "RM-BO-HDE-S",
                  "description": "Sand or silt"
              }
          ]
      },
      {
          "code": "RM-SO-HI",
          "description": "Infiltration",
          "feature": "Base",
          "type": "Observation",
          "field": "Observation",
          "dualLayer": true,
          "children": [
              {
                  "code": "RM-SO-HI-B",
                  "description": "Dripping"
              },
              {
                  "code": "RM-SO-HI-D",
                  "description": "Gushing"
              },
              {
                  "code": "RM-SO-HI-C",
                  "description": "Running"
              },
              {
                  "code": "RM-SO-HI-A",
                  "description": "Seepage"
              }
          ]
      },
      {
          "code": "RM-BO-HDP",
          "description": "Defective Drop Pipe",
          "feature": "Base",
          "type": "Observation",
          "field": "Observation",
          "dualLayer": true,
          "children": [
              {
                  "code": "RM-BO-HDP-B",
                  "description": "Blocked"
              },
              {
                  "code": "RM-BO-HDP-X",
                  "description": "Collapsed (deformation >25% )"
              },
              {
                  "code": "RM-BO-HDP-C",
                  "description": "Cracked"
              },
              {
                  "code": "RM-BO-HDP-D",
                  "description": "Deformed"
              },
              {
                  "code": "RM-BO-HDP-T",
                  "description": "Incorrect position causing turbulence and/or splashing"
              },
              {
                  "code": "RM-BO-HDP-M",
                  "description": "Missing, dislodged, separated or disconnected"
              },
              {
                  "code": "RM-BO-HDP-Z",
                  "description": "Other defect"
              }
          ]
      },
      {
          "code": "RM-BO-HEX",
          "description": "Exfiltration Observed",
          "feature": "Base",
          "type": "Observation",
          "field": "Observation",
          "dualLayer": true,
          "children": [
              {
                  "code": "RM-BO-HEX-D",
                  "description": "Exfiltration observed"
              }
          ]
      },
      {
          "code": "RM-BO-HGA",
          "description": "Atmosphere Within Structure",
          "feature": "Base",
          "type": "Observation",
          "field": "Observation",
          "dualLayer": true,
          "children": [
              {
                  "code": "RM-BO-HGA-CM",
                  "description": "Carbon monoxide"
              },
              {
                  "code": "RM-BO-HGA-HS",
                  "description": "Hydrogen sulphide"
              },
              {
                  "code": "RM-BO-HGA-ME",
                  "description": "Methane"
              },
              {
                  "code": "RM-BO-HGA-OF",
                  "description": "Other flammable gas"
              },
              {
                  "code": "RM-BO-HGA-Z",
                  "description": "Other hazard"
              },
              {
                  "code": "RM-BO-HGA-OD",
                  "description": "Oxygen deficiency or excess"
              }
          ]
      },
      // {
      //     "code": "RM-BO-HI",
      //     "description": "Flow Condition",
      //     "feature": "Base",
      //     "type": "Observation",
      //     "field": "Observation",
      //     "dualLayer": true,
      //     "children": [
      //         {
      //             "code": "RM-BO-HI-F",
      //             "description": "No flow"
      //         }
      //     ]
      // },
      {
          "code": "RM-BO-HIF",
          "description": "Flow Condition",
          "feature": "Base",
          "type": "Observation",
          "field": "Observation",
          "dualLayer": true,
          "children": [
              {
                  "code": "RM-BO-HI-F",
                  "description": "No flow"
              },
              {
                  "code": "RM-BO-HIF-CI",
                  "description": "Clear effluent"
              },
              {
                  "code": "RM-BO-HIF-SWI",
                  "description": "Sea water"
              },
              {
                  "code": "RM-BO-HIF-TI",
                  "description": "Turbid or discoloured"
              },
              {
                  "code": "RM-BO-HIF-ZYY",
                  "description": "Unknown nature of flow"
              }
          ]
      },
      {
          "code": "RM-BO-HOB",
          "description": "Other Obstacles",
          "feature": "Base",
          "type": "Observation",
          "field": "Observation",
          "dualLayer": true,
          "children": [
              {
                  "code": "RM-BO-HOB-P",
                  "description": "External pipe or cable built though the structure"
              },
              {
                  "code": "RM-BO-HOB-M",
                  "description": "Fragment of material lying in the channel"
              },
              {
                  "code": "RM-BO-HOB-MU",
                  "description": "Masonry unit lying in the channel or on the benching"
              },
              {
                  "code": "RM-BO-HOB-O",
                  "description": "Object built into the structure"
              },
              {
                  "code": "RM-BO-HOB-C",
                  "description": "Object entering through a connection"
              }
          ]
      },
      {
          "code": "RM-BO-HR",
          "description": "Roots",
          "feature": "Base",
          "type": "Observation",
          "field": "Observation",
          "dualLayer": true,
          "children": [
              {
                  "code": "RM-BO-HR-F",
                  "description": "Fine roots"
              },
              {
                  "code": "RM-BO-HR-M",
                  "description": "Interwoven clump or root mass"
              },
              {
                  "code": "RM-BO-HR-T",
                  "description": "Tap roots"
              }
          ]
      },
      {
          "code": "RM-BO-HTS",
          "description": "Silt Trap in Invert",
          "feature": "Base",
          "type": "Observation",
          "field": "Observation",
          "dualLayer": true,
          "children": [
              {
                  "code": "RM-BO-HTS-TPTM",
                  "description": "All or part of the trap missing with evidence that one was previously present"
              },
              {
                  "code": "RM-BO-HTS-TPTC",
                  "description": "Silt trap covered with debris"
              },
              {
                  "code": "RM-BO-HTS-TPTD",
                  "description": "Silt trap defective"
              },
              {
                  "code": "RM-BO-HTS-TPTF",
                  "description": "Silt trap full of silt and grit"
              },
              {
                  "code": "RM-BO-HTS-TP",
                  "description": "Silt trap present with no defects"
              }
          ]
      },
      {
          "code": "RM-BO-HV",
          "description": "Vermin",
          "feature": "Base",
          "type": "Observation",
          "field": "Observation",
          "dualLayer": true,
          "children": [
              {
                  "code": "RM-BO-HV-Z",
                  "description": "Vermin "
              }
          ]
      },
      {
          "code": "RM-BO-HW",
          "description": "Water Level",
          "feature": "Base",
          "type": "Observation",
          "field": "Observation",
          "dualLayer": true,
          "children": [
              {
                  "code": "RM-BO-HW-LFC",
                  "description": "Flow at constant depth and clear"
              },
              {
                  "code": "RM-BO-HW-LFT",
                  "description": "Flow at constant depth, turbid or discoloured"
              },
              {
                  "code": "RM-BO-HW-LN",
                  "description": "No water flow"
              },
              {
                  "code": "RM-BO-HW-LPC",
                  "description": "Ponding, clear water"
              },
              {
                  "code": "RM-BO-HW-LPT",
                  "description": "Ponding, turbid or discoloured water"
              }
          ]
      },
      {
          "code": "RM-BO-HX",
          "description": "Collapsed Structure",
          "feature": "Base",
          "type": "Observation",
          "field": "Observation",
          "dualLayer": true,
          "children": [
              {
                  "code": "RM-BO-HX-Z",
                  "description": "Collapsed structure"
              }
          ]
      },
      {
          "code": "RM-CO-HCF",
          "description": "Cover",
          "feature": "Above Ground",
          "type": "Observation",
          "field": "Observation",
          "dualLayer": true,
          "children": [
              {
                  "code": "RM-CO-HCF-CLZ",
                  "description": "Below ground level - unit"
              },
              {
                  "code": "RM-CO-HCF-CHZ",
                  "description": "Flush with ground level - unit"
              },
              {
                  "code": "RM-CO-HCF-LC",
                  "description": "Low cover level - unit"
              },
              {
                  "code": "RM-CO-HCF-CC",
                  "description": "Cracked cover - unit"
              },
              {
                  "code": "RM-CO-HCF-DC",
                  "description": "Damaged cover - unit"
              },
              {
                  "code": "RM-CO-HCF-CBZ",
                  "description": "Broken cover - unit"
              },
              {
                  "code": "RM-CO-HCF-VUC",
                  "description": "Voids under cover - unit"
              },
              {
                  "code": "RM-CO-HCF-DIS",
                  "description": "Displaced cover"
              },
              {
                  "code": "RM-CO-HCF-PFC",
                  "description": "Missing/Poorly fitted cover"
              },
          ]
      },
      {
          "code": "RM-SF-HSC",
          "description": "Surface",
          "feature": "Above Ground",
          "type": "Observation",
          "field": "Observation",
          "dualLayer": true,
          "children": [
              {
                  "code": "RM-SF-HSC-CKS",
                  "description": "Cracked surface"
              },
              {
                  "code": "RM-SF-HSC-DMS",
                  "description": "Damanged surface"
              },
              {
                  "code": "RM-SF-HSC-BKS",
                  "description": "Broken surface"
              }
          ]
      },
      {
          "code": "RM-SF-DCH",
          "description": "Discharge",
          "feature": "Above Ground",
          "type": "Observation",
          "field": "Observation",
          "dualLayer": true,
          "children": [
                {
                  "code": "RM-SF-DCH-DPG",
                  "description": "Down pipe to gully"
              },
              {
                  "code": "RM-SF-DCH-WPG",
                  "description": "Waste pipe to gully"
              },
              {
                  "code": "RM-SF-DCH-SWS",
                  "description": "Surface water to sewer"
              },
          ]
      },
      {
          "code": "RM-SU-HSC",
          "description": "Surround",
          "feature": "Above Ground",
          "type": "Observation",
          "field": "Observation",
          "dualLayer": true,
          "children": [
              {
                  "code": "RM-SU-HSC-NOS",
                  "description": "No surround"
              },
              {
                  "code": "RM-SU-HSC-LOS",
                  "description": "Low surround"
              },
              {
                  "code": "RM-SU-HSC-BRS",
                  "description": "Broken surround"
              },
                {
                    "code": "RM-SU-HSC-CRS",
                    "description": "Cracked surround"
                },
                {
                    "code": "RM-SU-HSC-INS",
                    "description": "Insufficient surround"
                }
          ]
      },
      {
          "code": "RM-SU-PLT",
          "description": "Vegetation",
          "feature": "Above Ground",
          "type": "Observation",
          "field": "Observation",
          "dualLayer": true,
          "children": [
              {
                  "code": "RM-SU-PLT-CSO",
                  "description": "Covered with soil"
              },
              {
                "code": "RM-SU-PLT-LEC",
                "description": "Covered with leaves"
            },
            {
                "code": "RM-SU-PLT-CVG",
                "description": "Covered with vegetation"
            },
            {
                "code": "RM-SU-PLT-RI",
                "description": "Roots ingress"
            }
          ]
      },
      {
          "code": "RM-SO-HB",
          "description": "Breaking",
          "feature": "Shaft",
          "type": "Observation",
          "field": "Observation",
          "dualLayer": true,
          "children": [
              {
                  "code": "RM-SO-HB-D",
                  "description": "Displaced pieces"
              }
          ]
      },
      {
          "code": "RM-SO-HC",
          "description": "Cracking",
          "feature": "Shaft",
          "type": "Observation",
          "field": "Observation",
          "dualLayer": true,
          "children": [
              {
                  "code": "RM-SO-HC-Z",
                  "description": "Cracking"
              }
          ]
      },
      {
          "code": "RM-SO-HDE",
          "description": "Deposit on Walls aaaaa",
          "feature": "Shaft",
          "type": "Observation",
          "field": "Observation",
          "dualLayer": true,
          "children": [
              {
                  "code": "RM-SO-HDE-E",
                  "description": "Encrustation"
              },
              {
                  "code": "RM-SO-HDE-F",
                  "description": "Fouling"
              },
              {
                  "code": "RM-SO-HDE-G",
                  "description": "Grease"
              }
          ]
      },
      {
          "code": "RM-SO-HI",
          "description": "Infiltration",
          "feature": "Shaft",
          "type": "Observation",
          "field": "Observation",
          "dualLayer": true,
          "children": [
              {
                  "code": "RM-SO-HI-B",
                  "description": "Dripping"
              },
              {
                  "code": "RM-SO-HI-D",
                  "description": "Gushing"
              },
              {
                  "code": "RM-SO-HI-C",
                  "description": "Running"
              },
              {
                  "code": "RM-SO-HI-A",
                  "description": "Seepage"
              }
          ]
      },
      {
          "code": "RM-SO-HJD",
          "description": "Displaced Joint",
          "feature": "Shaft",
          "type": "Observation",
          "field": "Observation",
          "dualLayer": true,
          "children": [
              {
                  "code": "RM-SO-HJD-A",
                  "description": "Angular"
              },
              {
                  "code": "RM-SO-HJD-H",
                  "description": "Horizontal"
              },
              {
                  "code": "RM-SO-HJD-V",
                  "description": "Vertical"
              }
          ]
      },
      {
          "code": "RM-SO-HLD",
          "description": "Defective Lining or Coating",
          "feature": "Shaft",
          "type": "Observation",
          "field": "Observation",
          "dualLayer": true,
          "children": [
              {
                  "code": "RM-SO-HLD-B",
                  "description": "Blistered"
              },
              {
                  "code": "RM-SO-HLD-CP",
                  "description": "Coating peeling off"
              },
              {
                  "code": "RM-SO-HLD-X",
                  "description": "Collapsed (deformation >50% )"
              },
              {
                  "code": "RM-SO-HLD-I",
                  "description": "Defective or irregular edges"
              },
              {
                  "code": "RM-SO-HLD-D",
                  "description": "Deformed or bulged"
              },
              {
                  "code": "RM-SO-HLD-H",
                  "description": "Holes or perforations"
              },
              {
                  "code": "RM-SO-HLD-Z",
                  "description": "Other defect"
              },
              {
                  "code": "RM-SO-HLD-R",
                  "description": "Roots from behind the lining"
              },
              {
                  "code": "RM-SO-HLD-T",
                  "description": "Torn, cut, slit or gouged generally by mechanical damage"
              },
              {
                  "code": "RM-SO-HLD-L",
                  "description": "Water flowing or leaking from behind the lining"
              },
              {
                  "code": "RM-SO-HLD-WD",
                  "description": "Weld defective"
              },
              {
                  "code": "RM-SO-HLD-W",
                  "description": "Wrinkled"
              }
          ]
      },
      {
          "code": "RM-SO-HM",
          "description": "Masonry",
          "feature": "Shaft",
          "type": "Observation",
          "field": "Observation",
          "dualLayer": true,
          "children": [
              {
                  "code": "RM-SO-HM-M",
                  "description": "Mortar missing"
              },
              {
                  "code": "RM-SO-HM-U",
                  "description": "Unit missing"
              },
              {
                  "code": "RM-SO-HM-S",
                  "description": "Unit separation"
              }
          ]
      },
      {
          "code": "RM-SO-HOB",
          "description": "Object",
          "feature": "Shaft",
          "type": "Observation",
          "field": "Observation",
          "dualLayer": true,
          "children": [
              {
                  "code": "RM-SO-HOB-P",
                  "description": "External pipe or cable built though the structure"
              },
              {
                  "code": "RM-SO-HOB-I",
                  "description": "intruding through the wall"
              },
              {
                  "code": "RM-SO-HOB-Z",
                  "description": "Other defect"
              },
              {
                  "code": "RM-SO-HOB-SM",
                  "description": "Sealing material intruding into the structure"
              },
              {
                  "code": "RM-SO-HOB-J",
                  "description": "Wedged in a joint"
              }
          ]
      },
      {
          "code": "RM-SO-HPR",
          "description": "Point Repair",
          "feature": "Shaft",
          "type": "Observation",
          "field": "Observation",
          "dualLayer": true,
          "children": [
              {
                  "code": "RM-SO-HPR-C",
                  "description": "Completely lined"
              },
              {
                  "code": "RM-SO-HPR-I",
                  "description": "Injection of sealing material"
              },
              {
                  "code": "RM-SO-HPR-L",
                  "description": "Localised lining or patch"
              },
              {
                  "code": "RM-SO-HPR-Z",
                  "description": "Other type of repair"
              },
              {
                  "code": "RM-SO-HPR-R",
                  "description": "Part replaced or patched"
              },
              {
                  "code": "RM-SO-HPR-PR",
                  "description": "Point repaired"
              }
          ]
      },
      {
          "code": "RM-SO-HR",
          "description": "Roots",
          "feature": "Shaft",
          "type": "Observation",
          "field": "Observation",
          "dualLayer": true,
          "children": [
              {
                  "code": "RM-SO-HR-F",
                  "description": "Fine roots"
              },
              {
                  "code": "RM-SO-HR-M",
                  "description": "Interwoven clump or root mass. of mostly fine roots"
              },
              {
                  "code": "RM-SO-HR-T",
                  "description": "Tap roots"
              }
          ]
      },
      {
          "code": "RM-SO-HS",
          "description": "Shaft in Good Condition",
          "feature": "Shaft",
          "type": "Observation",
          "field": "Observation",
          "dualLayer": true,
          "children": [
              {
                  "code": "RM-SO-HS-GC",
                  "description": "Good condition"
              }
          ]
      },
      {
          "code": "RM-SO-HSC",
          "description": "Surface Damage",
          "feature": "Shaft",
          "type": "Observation",
          "field": "Observation",
          "dualLayer": true,
          "children": [
              {
                  "code": "RM-SO-HSC-AE",
                  "description": "Aggregate exposed"
              },
              {
                  "code": "RM-SO-HSC-CP",
                  "description": "Build up of corrosion products"
              },
              {
                  "code": "RM-SO-HSC-H",
                  "description": "Hole in the wall"
              },
              {
                  "code": "RM-SO-HSC-Z",
                  "description": "Other form of surface damage"
              },
              {
                  "code": "RM-SO-HSC-S",
                  "description": "Spalling of concrete"
              },
              {
                  "code": "RM-SO-HSC-RE",
                  "description": "Steel reinforcement is exposed"
              }
          ]
      },
      {
          "code": "RM-SO-HSL",
          "description": "Step",
          "feature": "Shaft",
          "type": "Observation",
          "field": "Observation",
          "dualLayer": true,
          "children": [
              {
                  "code": "RM-SO-HSL-SB",
                  "description": "Bar bent"
              },
              {
                  "code": "RM-SO-HSL-SC",
                  "description": "Corroded"
              },
              {
                  "code": "RM-SO-HSL-LCC",
                  "description": "Corroded"
              },
              {
                  "code": "RM-SO-HSL-LC",
                  "description": "Cracked"
              },
              {
                  "code": "RM-SO-HSL-HC",
                  "description": "Handrail corroded"
              },
              {
                  "code": "RM-SO-HSL-SL",
                  "description": "Loose"
              },
              {
                  "code": "RM-SO-HSL-SM",
                  "description": "Missing"
              },
              {
                  "code": "RM-SO-HSL-ED",
                  "description": "Plastic encapsulation damaged"
              },
              {
                  "code": "RM-SO-HSL-LRM",
                  "description": "Rung missing"
              },
              {
                  "code": "RM-SO-HSL-RC",
                  "description": "Runner corroded"
              }
          ]
      },
      {
          "code": "RM-SO-HV",
          "description": "Vermin",
          "feature": "Shaft",
          "type": "Observation",
          "field": "Observation",
          "dualLayer": true,
          "children": [
              {
                  "code": "RM-SO-HV-Z",
                  "description": "Vermin "
              }
          ]
      },
      {
          "code": "RM-SO-HX",
          "description": "Collapsed Structure",
          "feature": "Shaft",
          "type": "Observation",
          "field": "Observation",
          "dualLayer": true,
          "children": [
              {
                  "code": "RM-SO-HX-Z",
                  "description": "Collapsed structure"
              }
          ]
      },
      {
          "code": "RM-BA-BE-BRI",
          "description": "Brickwork",
          "feature": "Base",
          "type": "Attributes",
          "field": "Benching Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-BA-BE-CONIN",
          "description": "Concrete cast insitu",
          "feature": "Base",
          "type": "Attributes",
          "field": "Benching Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-BA-BE-CONPRE",
          "description": "Concrete precast",
          "feature": "Base",
          "type": "Attributes",
          "field": "Benching Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-BA-BE-EPO",
          "description": "Epoxy",
          "feature": "Base",
          "type": "Attributes",
          "field": "Benching Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-BA-BE-GLA",
          "description": "Glass reinforced plastics",
          "feature": "Base",
          "type": "Attributes",
          "field": "Benching Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-BA-BE-PLA",
          "description": "Plastics",
          "feature": "Base",
          "type": "Attributes",
          "field": "Benching Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-BA-BE-OTH",
          "description": "Other - details shall be recorded in the remarks field",
          "feature": "Base",
          "type": "Attributes",
          "field": "Benching Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-BA-CH-BRI",
          "description": "Brickwork",
          "feature": "Base",
          "type": "Attributes",
          "field": "Channel Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-BA-CH-CLA",
          "description": "Clay - Vitrified",
          "feature": "Base",
          "type": "Attributes",
          "field": "Channel Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-BA-CH-CONIN",
          "description": "Concrete cast insitu",
          "feature": "Base",
          "type": "Attributes",
          "field": "Channel Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-BA-CH-CONPRE",
          "description": "Concrete precast",
          "feature": "Base",
          "type": "Attributes",
          "field": "Channel Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-BA-CH-EAR",
          "description": "Earthenware",
          "feature": "Base",
          "type": "Attributes",
          "field": "Channel Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-BA-CH-EPO",
          "description": "Epoxy",
          "feature": "Base",
          "type": "Attributes",
          "field": "Channel Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-BA-CH-GLA",
          "description": "Glass reinforced plastics",
          "feature": "Base",
          "type": "Attributes",
          "field": "Channel Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-BA-CH-PLA",
          "description": "Plastics",
          "feature": "Base",
          "type": "Attributes",
          "field": "Channel Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-BA-CH-POL",
          "description": "Polyvinylchloride",
          "feature": "Base",
          "type": "Attributes",
          "field": "Channel Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-BA-CH-OTH",
          "description": "Other - details shall be recorded in the remarks field",
          "feature": "Base",
          "type": "Attributes",
          "field": "Channel Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-CA-DC-150",
          "description": "150",
          "feature": "Above Ground",
          "type": "Attributes",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
        {
            "code": "RM-CA-DC-225",
            "description": "225",
            "feature": "Above Ground",
            "type": "Attributes",
            "field": "Diameter",
            "dualLayer": false,
            "children": null
        },
      {
          "code": "RM-CA-DC-300",
          "description": "300",
          "feature": "Above Ground",
          "type": "Attributes",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-CA-DC-350",
          "description": "350",
          "feature": "Above Ground",
          "type": "Attributes",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-CA-DC-500",
          "description": "500",
          "feature": "Above Ground",
          "type": "Attributes",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-CA-DC-540",
          "description": "540",
          "feature": "Above Ground",
          "type": "Attributes",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-CA-DC-600",
          "description": "600",
          "feature": "Above Ground",
          "type": "Attributes",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
        "code": "RM-CA-WD-150",
        "description": "150",
        "feature": "Above Ground",
        "type": "Attributes",
        "field": "Width",
        "dualLayer": false,
        "children": null
    },
      {
          "code": "RM-CA-WD-225",
          "description": "225",
          "feature": "Above Ground",
          "type": "Attributes",
          "field": "Width",
          "dualLayer": false,
          "children": null
      },
    {
        "code": "RM-CA-WD-300",
        "description": "300",
        "feature": "Above Ground",
        "type": "Attributes",
        "field": "Width",
        "dualLayer": false,
        "children": null
    },
    {
        "code": "RM-CA-WD-350",
        "description": "350",
        "feature": "Above Ground",
        "type": "Attributes",
        "field": "Width",
        "dualLayer": false,
        "children": null
    },
    {
        "code": "RM-CA-WD-500",
        "description": "500",
        "feature": "Above Ground",
        "type": "Attributes",
        "field": "Width",
        "dualLayer": false,
        "children": null
    },
    {
        "code": "RM-CA-WD-540",
        "description": "540",
        "feature": "Above Ground",
        "type": "Attributes",
        "field": "Width",
        "dualLayer": false,
        "children": null
    },
    {
        "code": "RM-CA-WD-600",
        "description": "600",
        "feature": "Above Ground",
        "type": "Attributes",
        "field": "Width",
        "dualLayer": false,
        "children": null
    },
      /*{
          "code": "RM-CA-DC-ENT",
          "description": "Enter your own ",
          "feature": "Cover",
          "type": "Attributes",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },*/
      {
          "code": "RM-CA-LR-H",
          "description": "Heavy",
          "feature": "Above Ground",
          "type": "Attributes",
          "field": "Load Rating",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-CA-LR-L",
          "description": "Light",
          "feature": "Above Ground",
          "type": "Attributes",
          "field": "Load Rating",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-CA-MC-CI",
          "description": "Cast iron",
          "feature": "Above Ground",
          "type": "Attributes",
          "field": "Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-CA-MC-CLA",
          "description": "Clay EW - VC",
          "feature": "Above Ground",
          "type": "Attributes",
          "field": "Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-CA-MC-CON",
          "description": "Concrete",
          "feature": "Above Ground",
          "type": "Attributes",
          "field": "Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-CA-MC-PLA",
          "description": "Plastic",
          "feature": "Above Ground",
          "type": "Attributes",
          "field": "Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-CA-MC-NOC",
          "description": "No cover",
          "feature": "Above Ground",
          "type": "Attributes",
          "field": "Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-CA-SC-CIR",
          "description": "Circular",
          "feature": "Above Ground",
          "type": "Attributes",
          "field": "Shape",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-CA-SC-REC",
          "description": "Rectangular",
          "feature": "Above Ground",
          "type": "Attributes",
          "field": "Shape",
          "dualLayer": false,
          "children": null
      },
      {
        "code": "RM-CA-SC-SQU",
        "description": "Square",
        "feature": "Above Ground",
        "type": "Attributes",
        "field": "Shape",
        "dualLayer": false,
        "children": null
      },
      {
          "code": "RM-CA-SC-OTH",
          "description": "Other",
          "feature": "Above Ground",
          "type": "Attributes",
          "field": "Shape",
          "dualLayer": false,
          "children": null
      },
      {
        "code": "RM-DET-INS-IGT",
        "description": "Inflow - ORG - Gully Trap",
        "feature": "Details",
        "type": "Attributes",
        "field": "Inspection Purpose",
        "dualLayer": false,
        "children": null
      },
      {
        "code": "RM-DET-INS-IST",
        "description": "Inflow - Smoke Testing",
        "feature": "Details",
        "type": "Attributes",
        "field": "Inspection Purpose",
        "dualLayer": false,
        "children": null
      },
      {
          "code": "RM-DET-INS-REN",
          "description": "Visual - Work Completed",
          "feature": "Details",
          "type": "Attributes",
          "field": "Inspection Purpose",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-DET-INS-NON",
          "description": "Visual - Work Not Completed",
          "feature": "Details",
          "type": "Attributes",
          "field": "Inspection Purpose",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-DET-INS-OTH",
          "description": "Other (input allowed)",
          "feature": "Details",
          "type": "Attributes",
          "field": "Inspection Purpose",
          "dualLayer": false,
          "children": null
      },
        {
            "code": "RM-DET-LOC-ABU",
            "description": "Against building",
            "feature": "Details",
            "type": "Attributes",
            "field": "Location Type",
            "dualLayer": false,
            "children": null
        },
        {
            "code": "RM-DET-LOC-VER",
            "description": "Berm / Verge / Gardens",
            "feature": "Details",
            "type": "Attributes",
            "field": "Location Type",
            "dualLayer": false,
            "children": null
        },
        {
            "code": "RM-DET-LOC-LWN",
            "description": "Lawn",
            "feature": "Details",
            "type": "Attributes",
            "field": "Location Type",
            "dualLayer": false,
            "children": null
        },
        {
            "code": "RM-DET-LOC-PLN",
            "description": "Planted area",
            "feature": "Details",
            "type": "Attributes",
            "field": "Location Type",
            "dualLayer": false,
            "children": null
        },
        {
            "code": "RM-DET-LOC-BUS",
            "description": "Bush",
            "feature": "Details",
            "type": "Attributes",
            "field": "Location Type",
            "dualLayer": false,
            "children": null
        },
        {
            "code": "RM-DET-LOC-FOO",
            "description": "Footpath",
            "feature": "Details",
            "type": "Attributes",
            "field": "Location Type",
            "dualLayer": false,
            "children": null
        },
        {
            "code": "RM-DET-LOC-CCD",
            "description": "Driveway - Concrete",
            "feature": "Details",
            "type": "Attributes",
            "field": "Location Type",
            "dualLayer": false,
            "children": null
        },
        {
            "code": "RM-DET-LOC-APD",
            "description": "Driveway - Asphalt",
            "feature": "Details",
            "type": "Attributes",
            "field": "Location Type",
            "dualLayer": false,
            "children": null
        },
        {
            "code": "RM-DET-LOC-GDD",
            "description": "Driveway - Gravel/Dirt",
            "feature": "Details",
            "type": "Attributes",
            "field": "Location Type",
            "dualLayer": false,
            "children": null
        },
        {
            "code": "RM-DET-LOC-ROA",
            "description": "Carriageway / Road",
            "feature": "Details",
            "type": "Attributes",
            "field": "Location Type",
            "dualLayer": false,
            "children": null
        },
        {
            "code": "RM-DET-LOC-BPS",
            "description": "Blocked Paved Surface",
            "feature": "Details",
            "type": "Attributes",
            "field": "Location Type",
            "dualLayer": false,
            "children": null
        },
        {
            "code": "RM-DET-LOC-OTH",
            "description": "Other",
            "feature": "Details",
            "type": "Attributes",
            "field": "Location Type",
            "dualLayer": false,
            "children": null
        },
        {
            "code": "RM-DET-NOD-GLT",
            "description": "ORG - Gully Trap",
            "feature": "Above Ground",
            "type": "Attributes",
            "field": "Node Type",
            "dualLayer": false,
            "children": null
        },
        {
          "code": "RM-DET-NOD-RDP",
          "description": "Roof Downpipe",
          "feature": "Above Ground",
          "type": "Attributes",
          "field": "Node Type",
          "dualLayer": false,
          "children": null
        },
        {
            "code": "RM-DET-NOD-SS",
            "description": "Surface to Sewer",
            "feature": "Above Ground",
            "type": "Attributes",
            "field": "Node Type",
            "dualLayer": false,
            "children": null
          },
          {
            "code": "RM-DET-NOD-MAN-WW",
            "description": "Manhole - Sewer",
            "feature": "Above Ground",
            "type": "Attributes",
            "field": "Node Type",
            "dualLayer": false,
            "children": null
          },
          {
            "code": "RM-DET-NOD-IO",
            "description": "IO - Rodding Eye",
            "feature": "Above Ground",
            "type": "Attributes",
            "field": "Node Type",
            "dualLayer": false,
            "children": null
          },
        {
            "code": "RM-DET-NOD-MAN-SW",
            "description": "Manhole - Storm",
            "feature": "Above Ground",
            "type": "Attributes",
            "field": "Node Type",
            "dualLayer": false,
            "children": null
        },
        {
            "code": "RM-DET-NOD-GUT",
            "description": "Guttering",
            "feature": "Above Ground",
            "type": "Attributes",
            "field": "Node Type",
            "dualLayer": false,
            "children": null
        },
        {
          "code": "RM-DET-NOD-EXP",
          "description": "Exposed Pipe",
          "feature": "Above Ground",
          "type": "Attributes",
          "field": "Node Type",
          "dualLayer": false,
          "children": null
        },
        {
            "code": "RM-DET-NOD-OTH",
            "description": "Other",
            "feature": "Above Ground",
            "type": "Attributes",
            "field": "Node Type",
            "dualLayer": false,
            "children": null
        },
      {
          "code": "RM-DET-PU-COM",
          "description": "Combined",
          "feature": "Details",
          "type": "Attributes",
          "field": "Pipe Use",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-DET-PU-SEW",
          "description": "Sewer",
          "feature": "Details",
          "type": "Attributes",
          "field": "Pipe Use",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-DET-PU-STO",
          "description": "Storm",
          "feature": "Details",
          "type": "Attributes",
          "field": "Pipe Use",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-DET-WEA-DRY",
          "description": "Dry",
          "feature": "Details",
          "type": "Attributes",
          "field": "Weather",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-DET-WEA-HEA",
          "description": "Heavy - Rain",
          "feature": "Details",
          "type": "Attributes",
          "field": "Weather",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-DET-WEA-LIG",
          "description": "Light - Rain",
          "feature": "Details",
          "type": "Attributes",
          "field": "Weather",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-CA-DC-Clock-12",
          "description": "12",
          "feature": "Base",
          "type": "Inlet",
          "field": "Clock Position",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-CA-DC-Clock-1",
          "description": "1",
          "feature": "Base",
          "type": "Inlet",
          "field": "Clock Position",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-CA-DC-Clock-2",
          "description": "2",
          "feature": "Base",
          "type": "Inlet",
          "field": "Clock Position",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-CA-DC-Clock-3",
          "description": "3",
          "feature": "Base",
          "type": "Inlet",
          "field": "Clock Position",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-CA-DC-Clock-4",
          "description": "4",
          "feature": "Base",
          "type": "Inlet",
          "field": "Clock Position",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-CA-DC-Clock-5",
          "description": "5",
          "feature": "Base",
          "type": "Inlet",
          "field": "Clock Position",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-CA-DC-Clock-6",
          "description": "6",
          "feature": "Base",
          "type": "Inlet",
          "field": "Clock Position",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-CA-DC-Clock-7",
          "description": "7",
          "feature": "Base",
          "type": "Inlet",
          "field": "Clock Position",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-CA-DC-Clock-8",
          "description": "8",
          "feature": "Base",
          "type": "Inlet",
          "field": "Clock Position",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-CA-DC-Clock-9",
          "description": "9",
          "feature": "Base",
          "type": "Inlet",
          "field": "Clock Position",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-CA-DC-Clock-10",
          "description": "10",
          "feature": "Base",
          "type": "Inlet",
          "field": "Clock Position",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-CA-DC-Clock-11",
          "description": "11",
          "feature": "Base",
          "type": "Inlet",
          "field": "Clock Position",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-IT-PD-AC",
          "description": "Asbestos cement",
          "feature": "Base",
          "type": "Inlet",
          "field": "Pipe Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-IT-PD-BR",
          "description": "Brickwork",
          "feature": "Base",
          "type": "Inlet",
          "field": "Pipe Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-IT-PD-CL",
          "description": "Cement lining ",
          "feature": "Base",
          "type": "Inlet",
          "field": "Pipe Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-IT-PD-VC",
          "description": "Clay - Vitrified",
          "feature": "Base",
          "type": "Inlet",
          "field": "Pipe Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-IT-PD-RC",
          "description": "Concrete reinforced",
          "feature": "Base",
          "type": "Inlet",
          "field": "Pipe Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-IT-PD-CP",
          "description": "Concrete unreinforced",
          "feature": "Base",
          "type": "Inlet",
          "field": "Pipe Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-IT-PD-DI",
          "description": "Ductile cast iron",
          "feature": "Base",
          "type": "Inlet",
          "field": "Pipe Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-IT-PD-EW",
          "description": "Earthenware",
          "feature": "Base",
          "type": "Inlet",
          "field": "Pipe Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-IT-PD-EP",
          "description": "Epoxy EP",
          "feature": "Base",
          "type": "Inlet",
          "field": "Pipe Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-IT-PD-GRP",
          "description": "Glass reinforced plastics",
          "feature": "Base",
          "type": "Inlet",
          "field": "Pipe Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-IT-PD-CI",
          "description": "Grey cast iron",
          "feature": "Base",
          "type": "Inlet",
          "field": "Pipe Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-IT-PD-P",
          "description": "Plastic",
          "feature": "Base",
          "type": "Inlet",
          "field": "Pipe Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-IT-PD-PE",
          "description": "Polyethylene",
          "feature": "Base",
          "type": "Inlet",
          "field": "Pipe Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-IT-PD-PVC",
          "description": "Polyvinylchloride",
          "feature": "Base",
          "type": "Inlet",
          "field": "Pipe Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-IT-PD-Z",
          "description": "Other",
          "feature": "Base",
          "type": "Inlet",
          "field": "Pipe Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-IT-PM-100",
          "description": "100",
          "feature": "Base",
          "type": "Inlet",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-IT-PM-150",
          "description": "150",
          "feature": "Base",
          "type": "Inlet",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-IT-PM-200",
          "description": "200",
          "feature": "Base",
          "type": "Inlet",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-IT-PM-225",
          "description": "225",
          "feature": "Base",
          "type": "Inlet",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-IT-PM-300",
          "description": "300",
          "feature": "Base",
          "type": "Inlet",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-IT-PM-375",
          "description": "375",
          "feature": "Base",
          "type": "Inlet",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-IT-PM-400",
          "description": "400",
          "feature": "Base",
          "type": "Inlet",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-IT-PM-450",
          "description": "450",
          "feature": "Base",
          "type": "Inlet",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-IT-PM-525",
          "description": "525",
          "feature": "Base",
          "type": "Inlet",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-IT-PM-600",
          "description": "600",
          "feature": "Base",
          "type": "Inlet",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-IT-PM-825",
          "description": "825",
          "feature": "Base",
          "type": "Inlet",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-OT-PD-100",
          "description": "100",
          "feature": "Base",
          "type": "Outlet",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-OT-PD-150",
          "description": "150",
          "feature": "Base",
          "type": "Outlet",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-OT-PD-200",
          "description": "200",
          "feature": "Base",
          "type": "Outlet",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-OT-PD-225",
          "description": "225",
          "feature": "Base",
          "type": "Outlet",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-OT-PD-300",
          "description": "300",
          "feature": "Base",
          "type": "Outlet",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-OT-PD-375",
          "description": "375",
          "feature": "Base",
          "type": "Outlet",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-OT-PD-400",
          "description": "400",
          "feature": "Base",
          "type": "Outlet",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-OT-PD-450",
          "description": "450",
          "feature": "Base",
          "type": "Outlet",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-OT-PD-525",
          "description": "525",
          "feature": "Base",
          "type": "Outlet",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-OT-PD-600",
          "description": "600",
          "feature": "Base",
          "type": "Outlet",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-OT-PD-825",
          "description": "825",
          "feature": "Base",
          "type": "Outlet",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-OT-PM-AC",
          "description": "Asbestos cement",
          "feature": "Base",
          "type": "Outlet",
          "field": "Pipe Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-OT-PM-BR",
          "description": "Brickwork",
          "feature": "Base",
          "type": "Outlet",
          "field": "Pipe Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-OT-PM-VC",
          "description": "Clay - vitrified",
          "feature": "Base",
          "type": "Outlet",
          "field": "Pipe Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-OT-PM-RC",
          "description": "Concrete reinforced",
          "feature": "Base",
          "type": "Outlet",
          "field": "Pipe Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-OT-PM-CP",
          "description": "Concrete unreinforced",
          "feature": "Base",
          "type": "Outlet",
          "field": "Pipe Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-OT-PM-DI",
          "description": "Ductile cast iron",
          "feature": "Base",
          "type": "Outlet",
          "field": "Pipe Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-OT-PM-EW",
          "description": "Earthenware",
          "feature": "Base",
          "type": "Outlet",
          "field": "Pipe Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-OT-PM-GRP",
          "description": "Glass reinforced plastics",
          "feature": "Base",
          "type": "Outlet",
          "field": "Pipe Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-OT-PM-CI",
          "description": "Grey cast iron",
          "feature": "Base",
          "type": "Outlet",
          "field": "Pipe Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-OT-PM-P",
          "description": "Plastic",
          "feature": "Base",
          "type": "Outlet",
          "field": "Pipe Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-OT-PM-PE",
          "description": "Polyethylene",
          "feature": "Base",
          "type": "Outlet",
          "field": "Pipe Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-OT-PM-PVC",
          "description": "Polyvinylchloride",
          "feature": "Base",
          "type": "Outlet",
          "field": "Pipe Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-OT-PM-Z",
          "description": "Other",
          "feature": "Base",
          "type": "Outlet",
          "field": "Pipe Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-SA-DS-150",
          "description": "150",
          "feature": "Shaft",
          "type": "Attributes",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-SA-DS-300",
          "description": "300",
          "feature": "Shaft",
          "type": "Attributes",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-SA-DS-450",
          "description": "450",
          "feature": "Shaft",
          "type": "Attributes",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-SA-DS-600",
          "description": "600",
          "feature": "Shaft",
          "type": "Attributes",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-SA-DS-900",
          "description": "900",
          "feature": "Shaft",
          "type": "Attributes",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-SA-DS-1050",
          "description": "1050",
          "feature": "Shaft",
          "type": "Attributes",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-SA-DS-1200",
          "description": "1200",
          "feature": "Shaft",
          "type": "Attributes",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-SA-DS-1350",
          "description": "1350",
          "feature": "Shaft",
          "type": "Attributes",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-SA-DS-1500",
          "description": "1500",
          "feature": "Shaft",
          "type": "Attributes",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-SA-DS-1800",
          "description": "1800",
          "feature": "Shaft",
          "type": "Attributes",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-SA-DS-2100",
          "description": "2100",
          "feature": "Shaft",
          "type": "Attributes",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-SA-DS-2400",
          "description": "2400",
          "feature": "Shaft",
          "type": "Attributes",
          "field": "Diameter",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-SA-MA-ALU",
          "description": "Aluminium alloy ",
          "feature": "Shaft",
          "type": "Attributes",
          "field": "Material of Steps",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-SA-MA-CAS",
          "description": "Cast Iron",
          "feature": "Shaft",
          "type": "Attributes",
          "field": "Material of Steps",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-SA-MA-GALS",
          "description": "Galvanised steel",
          "feature": "Shaft",
          "type": "Attributes",
          "field": "Material of Steps",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-SA-MA-PLA",
          "description": "Plastics",
          "feature": "Shaft",
          "type": "Attributes",
          "field": "Material of Steps",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-SA-MA-STA",
          "description": "Stainless steel ",
          "feature": "Shaft",
          "type": "Attributes",
          "field": "Material of Steps",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-SA-MA-OTH",
          "description": "Other",
          "feature": "Shaft",
          "type": "Attributes",
          "field": "Material of Steps",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-SA-SC-ENT",
          "description": "Circular",
          "feature": "Shaft",
          "type": "Attributes",
          "field": "Shape of Shaft",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-SA-SC-CIR",
          "description": "Rectangular",
          "feature": "Shaft",
          "type": "Attributes",
          "field": "Shape of Shaft",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-SA-SC-REC",
          "description": "Other",
          "feature": "Shaft",
          "type": "Attributes",
          "field": "Shape of Shaft",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-SA-SW-BRI",
          "description": "Brickwork",
          "feature": "Shaft",
          "type": "Attributes",
          "field": "Wall Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-SA-SW-CONIN",
          "description": "Concrete - cast insitu",
          "feature": "Shaft",
          "type": "Attributes",
          "field": "Wall Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-SA-SW-CONPRE",
          "description": "Concrete - precast ring",
          "feature": "Shaft",
          "type": "Attributes",
          "field": "Wall Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-SA-SW-EPO",
          "description": "Epoxy",
          "feature": "Shaft",
          "type": "Attributes",
          "field": "Wall Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-SA-SW-GLA",
          "description": "Glass reinforced plastics",
          "feature": "Shaft",
          "type": "Attributes",
          "field": "Wall Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-SA-SW-PLA",
          "description": "Plastics",
          "feature": "Shaft",
          "type": "Attributes",
          "field": "Wall Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-SA-SW-OTH",
          "description": "Other - details shall be recorded in the remarks field",
          "feature": "Shaft",
          "type": "Attributes",
          "field": "Wall Material",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-SA-TY-DOU",
          "description": "Double width steps",
          "feature": "Shaft",
          "type": "Attributes",
          "field": "Type of Steps",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-SA-TY-LAD",
          "description": "Ladder",
          "feature": "Shaft",
          "type": "Attributes",
          "field": "Type of Steps",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-SA-TY-NO",
          "description": "No provision",
          "feature": "Shaft",
          "type": "Attributes",
          "field": "Type of Steps",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-SA-TY-SIN",
          "description": "Single width steps",
          "feature": "Shaft",
          "type": "Attributes",
          "field": "Type of Steps",
          "dualLayer": false,
          "children": null
      },
      {
          "code": "RM-SA-TY-OTH",
          "description": "Other",
          "feature": "Shaft",
          "type": "Attributes",
          "field": "Type of Steps",
          "dualLayer": false,
          "children": null
      }
  ]
}